import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import "../login/login.css";
import axios from "../../api/axios"; // axios instance
import Header from "../../components/header/Header";
import Subscribe from "../../components/subscribe/Subscribe";
import Footer from "../../components/footer/Footer";
import { baseURL } from "../../constants/url";
import Swal from "sweetalert2";

export default function SignUp() {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    phone_number: "",
    email: "",
    password: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const inputs = document.querySelectorAll("input");
    inputs.forEach((input) => {
      if (input.value.trim() !== "") {
        input.classList.add("filled");
      }

      const onInput = () => {
        if (input.value.trim() !== "") {
          input.classList.add("filled");
        } else {
          input.classList.remove("filled");
        }
      };

      input.addEventListener("input", onInput);
      return () => input.removeEventListener("input", onInput);
    });
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.first_name.trim()) newErrors.first_name = "First name is required.";
    if (!formData.last_name.trim()) newErrors.last_name = "Last name is required.";
    if (!formData.phone_number.trim()) {
      newErrors.phone_number = "Phone number is required.";
    } else if (!/^\d{10}$/.test(formData.phone_number)) {
      newErrors.phone_number = "Phone number must be exactly 10 digits.";
    }
    if (!formData.email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email is invalid.";
    }
    if (!formData.password.trim()) {
      newErrors.password = "Password is required.";
    } else if (formData.password.length < 6) {
      newErrors.password = "Password must be at least 6 characters.";
    }
    return newErrors;
  };

  const handleSubmit = async () => {
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      const response = await axios.post(`${baseURL}common/signup`, formData);

      if (response.status === 201 || response.status === 200) {
        localStorage.setItem("user", JSON.stringify(response.data));

        Swal.fire({
          icon: "success",
          title: "Registration Successful",
          text: "Your account has been created successfully!",
          confirmButtonText: "Login",
        }).then(() => {
          navigate("/login");
        });

        setFormData({
          first_name: "",
          last_name: "",
          phone_number: "",
          email: "",
          password: "",
        });
      } else {
        setMessage(response.data.message || "Registration failed.");
      }
    } catch (error) {
      console.error("Signup Error:", error);

      if (error.response) {
        const errorMsg = error.response.data.message || "";

        // Check specific duplicate errors
        if (errorMsg.toLowerCase().includes("email")) {
          setErrors((prev) => ({ ...prev, email: "Email already registered." }));
        } else if (errorMsg.toLowerCase().includes("phone")) {
          setErrors((prev) => ({ ...prev, phone_number: "Phone number already registered." }));
        } else {
           Swal.fire({
                    title: "Email already exist",
                    text: "Please enter another email",
                    icon: "error",
                    cancelButtonColor: "#e83333",
	                  cancelButtonText: "Cancel",
                  })
          setMessage(errorMsg || "Registration failed, email already exist");
        }
      } else if (error.request) {
        setMessage("No response from server.");
      } else {
        setMessage("Something went wrong.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <div className="container-fluid login_bg">
        <div className="formContainer_box">
          <div className="formContainer">
            <h4 className="mb_20 form_title">Register your Account</h4>
            <div className="signUpContainer">
              <div className="inputSectionSplit">
                <input
                  type="text"
                  name="first_name"
                  className="firstName"
                  value={formData.first_name}
                  onChange={handleChange}
                />
                <label className="inputLabel">First Name</label>
                {errors.first_name && <p className="errorText">{errors.first_name}</p>}
              </div>

              <div className="inputSectionSplit">
                <input
                  type="text"
                  name="last_name"
                  className="lastName"
                  value={formData.last_name}
                  onChange={handleChange}
                />
                <label className="inputLabel">Last Name</label>
                {errors.last_name && <p className="errorText">{errors.last_name}</p>}
              </div>

              <div className="inputSectionSplit">
                <input
                  type="text"
                  name="phone_number"
                  className="phoneNumber"
                  value={formData.phone_number}
                  onChange={handleChange}
                  maxLength="10"
                  pattern="\d*"
                />
                <label className="inputLabel">Phone Number</label>
                {errors.phone_number && <p className="errorText">{errors.phone_number}</p>}
              </div>

              <div className="inputSectionSplit">
                <input
                  type="text"
                  name="email"
                  className="emailAddress"
                  value={formData.email}
                  onChange={handleChange}
                />
                <label className="inputLabel">Email Address</label>
                {errors.email && <p className="errorText">{errors.email}</p>}
              </div>

              <div className="inputSection">
                <input
                  type="password"
                  name="password"
                  className="password"
                  value={formData.password}
                  onChange={handleChange}
                />
                <label className="inputLabel">Password</label>
                {errors.password && <p className="errorText">{errors.password}</p>}
              </div>

              <div className="pb_20">
                <button className="saveForm" onClick={handleSubmit} disabled={loading}>
                  {loading ? "Signing Up..." : "Sign Up"}
                </button>
              </div>

              {message && <p className="formMessage">{message}</p>}

              <div className="pr_15 pb_15 text_right">
                <Link to="/login" className="font_13 common_color">Sign In</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Subscribe />
      <Footer />
    </>
  );
}
